import { useLocation } from 'react-router-dom';
import { SidebarItem } from '@/components/elements/SidebarItem';
// Icons:
import Auctions from '@/assets/img/icon/dashboard/Auctions.svg';
import Governance from '@/assets/img/icon/dashboard/Governance.svg';
import Marketplace from '@/assets/img/icon/dashboard/Marketplace.svg';
import Profile from '@/assets/img/icon/dashboard/Profile.svg';
import Staking from '@/assets/img/icon/dashboard/Staking.svg';
import Fusion from '@/assets/img/icon/dashboard/Fusion.svg';
import Leaderboards from '@/assets/img/icon/dashboard/Leaderboards.svg';
import Overview from '@/assets/img/icon/dashboard/Overview.svg';
import Settings from '@/assets/img/icon/dashboard/Settings.svg';
import Treasury from '@/assets/img/icon/dashboard/Treasury.svg';


export const Sidebar = () => {
    const location = useLocation();

    const sidebarItems = [
        { label: 'Overview', path: '/dashboard', icon: <img src={Overview} alt="Overview" className="w-4 h-4" /> },
        { label: 'Staking', path: '/dashboard/staking', icon: <img src={Staking} alt="Staking" className="w-4 h-4" /> },
        { label: 'Governance', path: '/dashboard/governance', icon: <img src={Governance} alt="Governance" className="w-4 h-3.5" /> },
        { label: 'Auctions', path: '/dashboard/auctions', icon: <img src={Auctions} alt="Auctions" className="w-4 h-4" />, badge: 'Live' },
        { label: 'Marketplace', path: '/dashboard/marketplace', icon: <img src={Marketplace} alt="Marketplace" className="w-4 h-4" /> },
        { label: 'Fusion Lab', path: '/dashboard/fusion', icon: <img src={Fusion} alt="Fusion Lab" className="w-3.5 h-4" /> },
        { label: 'Leaderboards', path: '/dashboard/leaderboards', icon: <img src={Leaderboards} alt="Leaderboards" className="w-4 h-4" /> },
        { label: 'Profile', path: '/dashboard/profile', icon: <img src={Profile} alt="Profile" className="w-3.5 h-4" /> },
        { label: 'Treasury & Education', path: '/dashboard/treasury', icon: <img src={Treasury} alt="Treasury" className="w-5 h-3.5" /> },
        { label: 'Settings', path: '/dashboard/settings', icon: <img src={Settings} alt="Settings" className="w-4 h-4" /> },
    ];

    return (
        <aside className="w-60 h-[calc(100vh-80px)] fixed left-0 top-[80px] bg-white/5 backdrop-blur-md overflow-hidden z-40">
            {/* Background glow */}
            <div className="w-96 h-96 absolute left-[-400px] bottom-0 opacity-60 bg-info rounded-full blur-[282.13px] pointer-events-none" />
            
            {/* Sidebar content */}
            <nav className="relative z-10 w-full pl-4 pr-2 py-6 flex flex-col gap-4">
                {sidebarItems.map((item) => (
                    <SidebarItem
                        key={item.path}
                        label={item.label}
                        path={item.path}
                        icon={item.icon}
                        badge={item.badge}
                        isActive={location.pathname === item.path}
                    />
                ))}
            </nav>
        </aside>
    );
};